module.exports = __webpack_public_path__ + "assets/4-sales-jobs-nyc.cbd85b27.png";